// =============================================================================
// BASE CONFIGURATION
// =============================================================================

// Protocol and Host Configuration
export const API_HOST = `${process.env.REACT_APP_HTTP_PROTOCOL}${process.env.REACT_APP_API_HOST}`;
export const API_BASE = '/api/v1';
export const STATIC_URL = (process.env.REACT_APP_STATIC_URL || `${API_HOST}/static`).replace(/\/$/, '') + '/';

// WebSocket Configuration  
export const WEB_SOCKET_BASE = `${process.env.REACT_APP_WS_PROTOCOL}${process.env.REACT_APP_API_HOST}`;

// =============================================================================
// API ENDPOINTS
// =============================================================================

// Authentication Endpoints
const AUTH_BASE = `${API_BASE}/auth`;
const USER_BASE = `${API_BASE}/user`;
const PASSWORD_BASE = `${API_BASE}/password`;

export const LOGIN_URL = `${API_BASE}/login/`;
export const LOGOUT_URL = `${API_BASE}/logout/`;
export const REGISTER_URL = `${API_BASE}/signup/`;
export const RESEND_EMAIL_URL = `${API_BASE}/auth/email/verify/resend/`;
export const EMAIL_CONFIRM_URL = `${API_BASE}/auth/email/verify/`;
export const LOGIN_PROVIDER_URL = `${AUTH_BASE}/provider/`;
export const USER_URL = `${USER_BASE}/`;
export const USER_PROFILE_UPLOAD_URL = `${USER_BASE}/profile-image/`;
export const USER_PROFILE_DELETE = `${USER_BASE}/delete-account/`;
export const USER_ADD_EMAIL_URL = `${USER_BASE}/add-email/`;
export const REQ_PASSWORD_RESET = `${API_HOST}${PASSWORD_BASE}/reset/`;
export const PASSWORD_RESET = `${PASSWORD_BASE}/reset/confirm/`;
export const CONTACT = `${API_BASE}/contact/`
export const CONFIG = `${API_BASE}/config/`

// Model Endpoints
const MODEL_BASE = `${API_BASE}/model`;
const USERMODEL_BASE = `${API_BASE}/usermodel`;

export const MODELS_URL = `${API_BASE}/models/`;
export const TAGS_URL = `${API_BASE}/models/tags/`;
export const MODEL_URL = `${MODEL_BASE}/`;
export const USERMODELS_URL = `${API_BASE}/usermodels/`;
export const USERMODEL_URL = `${USERMODEL_BASE}/`;
export const INIT_USERMODEL_URL = `${USERMODEL_BASE}/init/`;
export const GENERATE_USERMODEL_URL = `${USERMODEL_BASE}/generate/`;
export const UPLOAD_PHOTO_URL = `/upload_photo/`;

// Plan Endpoints
const PLAN_BASE = `${API_BASE}/plan`;

export const PLANS_URL = `${API_BASE}/plans/`;
export const PLAN_URL = `${PLAN_BASE}/`;

// =============================================================================
// WEBSOCKET ENDPOINTS
// =============================================================================

export const WEB_SOCKET_STATUS = `${WEB_SOCKET_BASE}/ws/status/`;

// =============================================================================
// APPLICATION CONSTANTS
// =============================================================================

export const IMG_EXTENSION = '.webp';

// Model Build Timeout Configuration
// Timeout for model build operations in milliseconds (default: 1 minute) per stage/state
// Can be adjusted based on expected build times and user experience requirements
export const BUILD_ERROR_TIMEOUT = 60000;

// Pagination Configuration
// Page sizes for different screens and content types
export const PAGINATION = {
  MODELS: {
    DESKTOP: 16,
    MOBILE: 4
  },
  USER_MODELS: {
    DESKTOP: 4,
    MOBILE: 5
  },
  PLANS: {
    DESKTOP: 8,
    MOBILE: 6
  },
  PHOTOS: {
    DESKTOP: 12,
    MOBILE: 6
  }
};